import client from './client';
import { EnCryptData, DeCryptData } from '../util/CustomUtil';

// 카테고리 고리 통계 정보  가져오기
export const getElkCateStatsInfo = ({ cateItems, brandId }) => {

    let params = new URLSearchParams();
    params.append('cateItems', cateItems);
    params.append('brandId', brandId);
    return client.post('/prod/stats', params);
}

// 전체 상품 조회
export const getElkProds = ({ cateItems, brandId, filterItems, curPage, cate2Id, prodPrice }) => {

    let params = new URLSearchParams();
    params.append('cateItems', cateItems);
    params.append('brandId', brandId === null ? 0 : brandId);
    params.append('filterItems', filterItems);
    params.append('curPage', curPage);
    params.append('cate2Id', cate2Id);

    // console.log('prodPrice : ' + JSON.stringify(prodPrice));
    // console.log('cateItems : ' + JSON.stringify(cateItems));
    // console.log('cate2Id : ' + cate2Id);
    if (prodPrice.max > 0 && prodPrice.min > 0) {
        params.append('minprice', prodPrice.min);
        params.append('maxprice', prodPrice.max);
    }

    return client.post('/prod', params);
}

// 상품 가격 통계 정보 조회
export const getElkPriceStats = ({ brandId, cate2Id }) => {
    let params = new URLSearchParams();
    let cateItems = [];
    cateItems.push(cate2Id);
    params.append('cateItems', cateItems);
    params.append('brandId', brandId);
    return client.post('/prod/stats', params);
}

// 상품의 옵션 가격 정보 조회
export const getOptionPrice = ({ optioninfo }) => {
    let params = new URLSearchParams();
    params.append('prodid', optioninfo.prdct_id);
    params.append('opt1', optioninfo.opt1);
    params.append('opt2', optioninfo.opt2);
    params.append('opt3', optioninfo.opt3);
    return client.post('/prod/option', params);
}


export const getBrandHomeProds = ({ cateId, brandId, filterItems = null, curPage, minprice = -1, maxprice = -1, sort = 0 }) => {

    let urlString = "/prod/list?cateid=" + cateId + "&brandid=" + brandId + "&curpage=" + curPage;
    if (filterItems !== null && filterItems.length > 0) {
        let filterString = "&filter=" + filterItems;
        //console.log("getBrandHomeProds filterString = "+filterString);
        urlString = urlString.concat(filterString)
        //console.log("getBrandHomeProds urlString111 = "+urlString);
    }

    if (minprice > 0 && maxprice > 0) {
        let priceString = "&minprice=" + minprice + "&maxprice=" + maxprice;
        //console.log("getBrandHomeProds filterString = "+priceString);
        urlString = urlString.concat(priceString)
        //console.log("getBrandHomeProds urlString111 = "+urlString);
    }

    // console.log("sort : " + sort);
    let sortString = "&sort=";
    if (sort === 0) {
        sortString += "pop";
    } else if (sort === 1) {
        sortString += "reg";
    } else if (sort === 2) {
        sortString += "max";
    } else if (sort === 3) {
        sortString += "min";
    }
    urlString = urlString.concat(sortString)

    // console.log("getBrandHomeProds = " + urlString);
    return client.get(urlString);

}

/**
 * 상품 상세 정보
 * @param {*} param0
 */
export const getProdDetail = ({ locinfo }) => {
    let strUrl = "/prod" + locinfo;
    return client.get(strUrl);
}

/**
 * 상품 옵션 가격 정보 가져오기
 * @param {*} param0
 */
export const getProdOptPrice = ({ prodid, opt1, opt2 }) => {
    let strUrl = "/prod/option?prodid=" + prodid;
    if (opt1 !== null) strUrl += ("&opt1=" + opt1);
    if (opt2 !== null) strUrl += ("&opt2=" + opt2);
    
    var ua = navigator.userAgent.toLocaleLowerCase();
    var is_ie = ua.indexOf("msie ") > -1 || ua.indexOf("trident/") > -1;
    let _strUrl = strUrl
    if(is_ie) {
        _strUrl = encodeURI(strUrl)
    }
    
    return client.get(_strUrl);
}

/**
 * Main 상품 리스트 가져오기
 */
export const getMainList = () => client.get('/prod/main');
export const getEsList = () => client.get('/prod/es');

// 상품 클립 추가
export const prodAdd = ({ email, prodid }) => {
    let paramdata = { email, prodid };
    let params = new URLSearchParams();
    params.append('data', EnCryptData(JSON.stringify(paramdata)));
    return client.post('/user/prod/add', params);
}

//상품 클립 제거
export const prodDel = ({ email, prodid }) => {
    let paramdata = { email, prodid };
    let params = new URLSearchParams();
    params.append('data', EnCryptData(JSON.stringify(paramdata)));
    return client.post('/user/prod/del', params);
}

//상품 클립 전체 제거
export const prodDelAll = ({ email, brandid }) => {
    let paramdata = { email, brandid };
    let params = new URLSearchParams();
    params.append('data', EnCryptData(JSON.stringify(paramdata)));
    return client.post('/user/prod/alldell', params);
}

//로컬 저장된 장바구니 품절 정보
export const getCartSoldInfo = (param) => client.get('/user/prod/sold' + param);


export const getEsFilterInfo = ({cateId, brandIds}) => {
    let params = new URLSearchParams();
    params.append('cate_id_list', cateId);
    params.append('brandIds', brandIds);
    return client.post('/prod/filterinfomystep4', params);
}

export const getEsCountPDFilterInfo = ({ cate_id_list, filter, cate3Ids, minprice, maxprice, brandIds, search }) => {
    let params = new URLSearchParams();
    params.append('cate_id_list', cate_id_list);
    params.append('filter', filter);
    params.append('cate3Ids', cate3Ids);
    params.append('minprice', minprice);
    params.append('maxprice', maxprice);
    params.append('brandIds', brandIds);
    params.append('search', search);
    return client.post('/prod/countprodstep4', params);
}

export const getEsProdFilterInfo = ({ cate_id_list, filter, cate3Ids, minprice, maxprice, brandIds,curpage, sort, mobile }) => {
    let params = new URLSearchParams();

    //console.log("getEsProdFilterInfo")
    let sortString = "reg";
    if (sort*1 === 2) {
        sortString = "reg";
    } else if (sort*1 === 1) {
        sortString = "pop";
    } else if (sort*1 === 4) {
        sortString = "max";
    } else if (sort*1 === 3) {
        sortString = "min";
    }

    //console.log("sort = " + sortString);
    params.append('cate_id_list', cate_id_list);
    params.append('filter', filter);
    params.append('cate3Ids', cate3Ids);
    params.append('minprice', minprice);
    params.append('maxprice', maxprice);
    params.append('brandIds', brandIds);
    params.append('curpage', curpage);
    params.append('sort', sortString);
    params.append('mobile', mobile);
    return client.post('/prod/prodstep4', params);
}

export const getEsBrandFilterInfo = ({ cate_id_list, brandIds }) => {
    let params = new URLSearchParams();
    params.append('cate_id_list', cate_id_list);
    params.append('brandIds', brandIds);
    return client.post('/prod/brandinfostep4', params);
}


export const getProdFilterInfo = ({ cate1Id, cate2Id, filter, cate3Ids, minprice, maxprice, brandIds,curpage, sort, mobile, search }) => {
    let params = new URLSearchParams();

    //console.log("getEsProdFilterInfo")
    let sortString = "reg";
    if (sort*1 === 1) {
        sortString = "reg";
    } else if (sort*1 === 0) {
        sortString = "pop";
    } else if (sort*1 === 2) {
        sortString = "max";
    } else if (sort*1 === 3) {
        sortString = "min";
    }

    //console.log("sort = " + sortString);
    params.append('cate1Id', cate1Id);
    params.append('cate2Id', cate2Id);
    params.append('filter', filter);
    params.append('cate3Ids', cate3Ids);
    params.append('minprice', minprice);
    params.append('maxprice', maxprice);
    params.append('brandIds', brandIds);
    params.append('curpage', curpage);
    params.append('sort', sortString);
    params.append('mobile', mobile);
    params.append('search', search);
    return client.post('/prod/prodcategory', params);
}

export const getCategoryFilterInfo = ({cate1Id, cate2Id, brandIds, search}) => {
    let params = new URLSearchParams();
    params.append('cate1Id', cate1Id);
    params.append('cate2Id', cate2Id);
    params.append('brandIds', brandIds);
    params.append('search', search);
    return client.post('/prod/filterinfocategory', params);
}

export const getCategoryCountFromPriceInfo = ({cate1Id, cate2Id, brandIds, minprice, maxprice, search}) => {
    let params = new URLSearchParams();
    params.append('cate1Id', cate1Id);
    params.append('cate2Id', cate2Id);
    params.append('brandIds', brandIds);
    params.append('minprice', minprice);
    params.append('maxprice', maxprice);
    params.append('search', search);
    return client.post('/prod/countfromprice', params);
}